import {
  Autocomplete,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Tooltip,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useCallback, useEffect, useState } from "react";
import { Division } from "../../../models/Division";
import { RequestToSend } from "../../../models/RequestToSend";
import { Section } from "../../../models/Section";
import { User } from "../../../models/User";
import {
  addRequestToSend,
  addRequestsToSend,
} from "../../../redux/features/appStateSlice";
import {
  planoAPI
} from "../../../redux/features/cache";
import { useAppDispatch } from "../../../redux/store";

export interface IFormNewSection {
  setNewSection: (section: Section) => void;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const FormNewSection = ({ setNewSection }: IFormNewSection) => {
  const dispatch = useAppDispatch();

  const [opens, setOpens] = useState<boolean>(false);
  const handleCloses = () => setOpens(false);
  const handleOpens = () => setOpens(true);

  const [dirty, setDirty] = useState<boolean>(false);
  const [newSectionName, setNewSectionName] = useState<string | null>(null);
  const [ordre, setOrdre] = useState<number | null>(null);
  const [divisionNumber, setDivisionNumber] = useState<number | null>();
  const [buyerNames, setBuyerNames] = useState<string[]>([]);
  const [division, setDivision] = useState<Division | null>(null);

  const { data: divisions = [] as Division[] } = planoAPI.endpoints.getDivisions.useQuery({
    treeView: false,
    includeSections: false,
    plano: false,
  });

  const { data: buyers = [] as User[] } = planoAPI.endpoints.getUsers.useQuery({
    fonction: "Acheteur",
    sort: "usr_nom",
    div_num: "",
  });

  const [addSection] = planoAPI.endpoints.addSection.useMutation();
  const [addAcheteur] = planoAPI.endpoints.addAcheteur.useMutation();

  const handleSubmit = useCallback(async () => {

    const requestTitle = `Ajout section ${newSectionName}`;
    const callbackFunction = (addedSection: Section) => {

      if (addedSection.plans_seq) {
        const key = buyerNames.map((buyerName) =>
          buyers.find((buyer) => buyer.usr_nom === buyerName)?.usr_cd
        );

        const addBuyersTask = key.map((element) => {
          return new RequestToSend(
            `Ajout acheteur ${element}`,
            addAcheteur,
            () => { },
            {},
            {
              plans_seq: addedSection.plans_seq,
              usr_cd: element
            },
            []
          );
        });

        dispatch(addRequestsToSend(addBuyersTask));
        setNewSection(addedSection);
      }
    };

    const newSection = {
      plans_nom: newSectionName,
      div_num: divisionNumber,
      plans_ordre: ordre,
      // division: [division],
    } as Section;

    const request = new RequestToSend(
      requestTitle,
      addSection,
      callbackFunction,
      {},
      newSection,
      []
    )

    dispatch(addRequestToSend(request));

  }, [newSectionName, divisionNumber, ordre, division, addSection, dispatch, buyerNames, setNewSection, buyers, addAcheteur]);

  const handleDeletes = async (e: any) => {
    setDirty(true);
    let newPerson = buyerNames.filter((x) => x !== e);
    setBuyerNames(newPerson);
  };

  const handleChange = (event: SelectChangeEvent<typeof buyerNames>) => {
    const {
      target: { value },
    } = event;
    setBuyerNames(typeof value === "string" ? value.split(",") : value);
  };

  useEffect(() => {

    if (divisionNumber != null) {
      const division = divisions.find((div) => div.div_num === divisionNumber) || null; 
      setDivision(division);
      console.log("division is set");
    }
  }, [divisionNumber, divisions]);

  return (
    <Box id="form-new-section">
      <Box sx={{ display: "flex" }}>
        <TextField
          required
          label="Nom de la section"
          sx={{ m: 1 }}
        onChange={(event) => setNewSectionName(event.target.value)}
        />
        <Autocomplete
          options={divisions}
          getOptionLabel={(allDiv: Division) =>
            `${allDiv.div_num} ${allDiv.div_nom}`
          }
          onInputChange={async (event) => {
            event?.stopPropagation();
          }}
          sx={{
            width: 300,
            m: 1,
            "& input.Mui-disabled": { WebkitTextFillColor: "Black" },
          }}
          onChange={(e, data) => {
            setDirty(true);
            setDivisionNumber(data!.div_num);
          }}
          renderInput={(params) => (
            <TextField
              required
              onClick={(e) => e.stopPropagation()}
              {...params}
              variant="outlined"
              label="Division"
            />
          )}
        />
        <TextField
          type="number"
          sx={{ m: 1 }}
          label="Ordre"
          InputProps={{
            inputProps: {
              min: 0,
            },
          }}
          onChange={(event) => setOrdre(parseInt(event.target.value))}
        />
        <FormControl sx={{ m: 1, width: 600 }}>
          <InputLabel
            id="demo-multiple-name-label"
            sx={{
              backgroundColor: "#ffffff",
              paddingLeft: "5px",
              paddingRight: "5px",
            }}
          >
            Acheteur
          </InputLabel>
          <Select
            sx={{
              padding: 0,
              maxHeight: 56,
              "& input.Mui-disabled": { WebkitTextFillColor: "Black" },
            }}
            id="demo-multiple-name"
            open={opens}
            onClose={(e) => {
              e.stopPropagation();
              handleCloses();
            }}
            onOpen={handleOpens}
            multiple
            value={buyerNames}
            onChange={(e) => {
              e.stopPropagation();
              handleChange(e);
              setDirty(true);
            }}
            MenuProps={MenuProps}
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip
                    key={value}
                    label={value}
                    onMouseDown={(e) => e.stopPropagation()}
                    onDelete={() => {
                      handleDeletes(value);
                    }}
                    sx={{ WebkitTextFillColor: "black" }}
                  />
                ))}
              </Box>
            )}
          >
            {buyers.map((buyer) => (
              <MenuItem
                key={buyer.usr_nom}
                value={buyer.usr_nom}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                {buyer.usr_nom}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Tooltip title="Enregistrer">
          <span
            style={{
              display: "flex",
              alignItems: "center",
              padding: "6px 28px",
              cursor: "pointer",
            }}
            className={`save-wrapper ${!dirty ? "custom-disabled" : ""}`}
          >
            <span
              className={`k-icon k-font-icon k-i-save k-icon-xl`}
              onClick={handleSubmit}
            ></span>
          </span>
        </Tooltip>
      </Box>
    </Box>
  );
};
